module.exports = __webpack_public_path__ + "img/btn_noti_normal.1e788abd.svg";